var $5483d78ae26698b2$exports = {};
$5483d78ae26698b2$exports = {
    "more": `\u{3A0}\u{3B5}\u{3C1}\u{3B9}\u{3C3}\u{3C3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3B1} \u{3C3}\u{3C4}\u{3BF}\u{3B9}\u{3C7}\u{3B5}\u{3AF}\u{3B1}`
};


export {$5483d78ae26698b2$exports as default};
//# sourceMappingURL=el-GR.mjs.map
